import React from "react";
import { useLocation } from "react-router-dom";

export const ErrorPage = () => {
  const location = useLocation();
  return <div>Error {location.state ? location.state.status : " 404"}</div>;
};

export default ErrorPage;
